import dashboard from './dashboard'
import detect from './detect'
import forgery from './forgery'
import forgerydetect from './forgerydetect'
import pattern from './pattern'
import policy from './policy'
import report from './report'
import result from './result'
import schedule from './schedule'
import site from './site'

const wmds_v2 = {
  dashboard, detect, forgery, forgerydetect, pattern, policy, report, result, schedule, site
}

export default wmds_v2

export { dashboard, detect, forgery, forgerydetect, pattern, policy, report, result, schedule, site }